<template lang="pug">
  main
    NavBarInventario
    Loader(v-show="isLoading")
    section.section(v-show="!isLoading")
      .container
        .columns
          .column.is-half.is-offset-one-quarter.has-text-centered
            h1.is-size-3 Facturas 
              |
              router-link.a.button.is-dark.is-rounded.is-size-6.is-medium(to='/Asistentes')
                i.fas.fa-times
            br
        .columns
          .column.is-4
            label.label Fecha de Factura:
        .columns
          .column.is-4
            .field
              .control
                flat-pickr(
                  v-model='fechaInicio'
                  :config="config"
                  class="input"
                )
          .column.is-1.has-text-right
            a.button.is-success()
              | Descargar Facturas
          .column.is-4.has-text-right
            router-link.a.button.is-ligth(v-show="permisos.facturas != 6" to="/Factura/Alta")
              | + Nueva Factura
            | &nbsp
            a.button.is-ligth()
              | Buscar
          .column.is-3.has-text-right
                input.input.is-primary(
                  type='text', 
                  placeholder='Buscar Factura',
                  v-model="factura",
                )
      .container
        .columns
        .column.is-half.is-offset-one-quarter.has-text-centered
        .columns
            .table-responsive
            table#tbExistencias.table.is-striped.is-fullwidth
              thead
                tr
                  th Factura
                  th Empresa
                  th Partida Presupuestada
                  th OC
                  th UUID
                  th Proveedor
                  th Monto y Concepto
                  th Fecha De Pago
                  th Metodo De Pago
              tbody
                tr(v-for="(data, index) in facturas" :key="data.id")
                  td
                    span.tag.is-ligth {{ data.factura }}
                  td
                    span.tag.is-ligth {{ data.empresa }}
                  td
                    span.tag.is-ligth {{ data.partidaPresupuestal }} &nbsp&nbsp
                    span.tag.is-ligth {{ data.fechaFactura }} &nbsp&nbsp
                    span.tag.is-ligth {{ data.area }} &nbsp&nbsp
                  td
                    span.tag.is-ligth {{ data.ordenCompra }} &nbsp&nbsp
                    span.tag.is-ligth {{ data.serie }} &nbsp&nbsp
                    span.tag.is-ligth {{ data.folio }} &nbsp&nbsp
                  td
                    span.tag.is-ligth {{ data.UUID }}
                  td
                    span.tag.is-ligth {{ data.proveedor}}
                  td
                    span.tag.is-ligth {{ data.monto }} &nbsp&nbsp
                    span.tag.is-ligth {{ data.concepto }} &nbsp&nbsp  
                  td
                    span.tag.is-ligth {{ data.fechaPago }}
                  td
                    span.tag.is-ligth {{ data.metodoPago }}


</template>

<script>
  import { mapState } from 'vuex'
  import Loader from '../../shared/Loader.vue'
  import InventarioServices from '../../../services/inventario/inventario'
  import FacturaServices from '../../../services/inventario/facturas'
  import NavBarInventario from '../../inventario_Componentes/layout/NavBarInventario.vue'
  import moment from 'moment'
  import flatPickr from 'vue-flatpickr-component'
  import 'flatpickr/dist/flatpickr.css'
  import { Spanish } from "flatpickr/dist/l10n/es.js"
  export default {
  name: 'NuevaFactura',
  components: { Loader, NavBarInventario, flatPickr},
  data () { 
    return {
      isLoading: true,
      facturas: [],
      factura: '',
      oficinas: [],
      date: '',
      area: '',
      userNormal: true,
      fechaInicio: moment().format('YYYY-MM-DD'),
      fechaFin: moment(this.fechaInicio).add(1, 'days').format('YYYY-MM-DD'),
      config: {
          wrap: true, // set wrap to true only when using 'input-group'
          altFormat: 'Y-m-d',
          altInput: true,
          dateFormat: 'Y-m-d',
          locale: Spanish, // locale for this instance only          
        },
    }
  },

  methods: {
    iniciarComponente() {
      if (this.userLogin.area) {
          this.userNormal = false
        }
        this.obtenerOficinas()
        this.obtenerFacturas()
      },

    obtenerFacturas () {
        FacturaServices.getFactura(this.userLogin.id_oficina)
          .then(data => {
            this.facturas = data 
          })
          .catch( e => {
            this.isLoading = false
            console.log(`Error: ${e.message}`)
          })
      },

    obtenerOficinas() {
       InventarioServices.getOficinas()
         .then( data => {
           this.oficinas = data.map(this.convertirOficinas)
           this.isLoading = false
         })
         .catch((e) => {
           this.isLoading = false
           console.log(`Error: ${e.message}`)
         })
     },

    convertirOficinas(ofi) {
      return {
        ...ofi,
        id: parseInt(ofi.id),
        oficina: ofi.nombre,
        id_ubicacion: parseInt(ofi.id_ubicacion),
        inventario: parseInt(ofi.inventario) == 1 ? true : false,
      }
    },

    },

    created () {
    this.iniciarComponente()
    },

    computed: {
      ...mapState(['permisos', 'userLogin'])
    }
  }
  

</script>



// WEBPACK FOOTER //
// src/components/asistentes_Componentes/facturas/FacturasAsistentes.vue